import React from "react";
import { StaticImage } from "gatsby-plugin-image";

// components
import ReusableForm from "../Global/ReusableForm/ReusableForm";

// css
import * as styles from "./ContactUs.module.css";

const FormBanner = ({
  formFields,
  handleFormSubmit,
  loading,
  ctaText,
  mixpanelPageName,
  formIsModal,
  showCheckbox,
  checkboxText,
  checkboxColor,
  buttonStyles,
}) => {
  return (
    <section className={styles.contactWrapper}>
      <div className={styles.contactContainer}>
        <div className={styles.contentWrapper}>
          {/* Image Column */}
          <div className={styles.imageColumn}>
            <div className={styles.imageContainer}>
              <StaticImage
                src="../../images/contact/contact-desktop.png"
                alt="Contact Twin Health"
                className={styles.desktopImage}
                placeholder="blurred"
                loading="lazy"
              />
              <StaticImage
                src="../../images/contact/contact-mobile.png"
                alt="Contact Twin Health"
                className={styles.mobileImage}
                placeholder="blurred"
                loading="lazy"
              />
            </div>
          </div>

          {/* Form Column */}
          <div className={styles.formColumn}>
            <div className={styles.formSection}>
              <h1 className={styles.formTitle}>Get in touch</h1>

              <ReusableForm
                fields={formFields}
                onSubmit={handleFormSubmit}
                ctaText={ctaText}
                loading={loading}
                mixpanelPageName={mixpanelPageName}
                formIsModal={formIsModal}
                showCheckbox={showCheckbox}
                checkboxText={checkboxText}
                checkboxColor={checkboxColor}
                buttonStyles={buttonStyles}
              />

              {/* Connect With Our Team */}
              <div className={styles.contactInfo}>
                <h2 className={styles.contactTitle}>Connect With Our Team</h2>

                <div className={styles.addressCardsGrid}>
                  {/* Global HQ Card */}
                  <div className={styles.addressCard}>
                    <div className={styles.cardHeader}>
                      <StaticImage
                        src="../../images/contact/location_icn.png"
                        alt="Location_Icon"
                        className={styles.locationIcon}
                        placeholder="none"
                        quality={100}
                      />
                      <span className={styles.cardTitle}>Global HQ</span>
                    </div>
                    <p className={styles.cardAddress}>
                      4200 Bohannon Dr #280, Menlo Park, CA 94025, United States
                    </p>
                  </div>

                  {/* India HQ Card */}
                  <div className={styles.addressCard}>
                    <div className={styles.cardHeader}>
                      <StaticImage
                        src="../../images/contact/location_icn.png"
                        alt="Location_Icon"
                        className={styles.locationIcon}
                        placeholder="none"
                        quality={100}
                      />
                      <span className={styles.cardTitle}>India HQ</span>
                    </div>
                    <p className={styles.cardAddress}>
                      RMZ Millenia Business Park Phase 2, Symbyont Smart Spaces
                      Campus 5, 8th Floor, Perungudi, Chennai – 600096
                    </p>
                  </div>

                  {/* Regional Office Card */}
                  <div className={styles.addressCard}>
                    <div className={styles.cardHeader}>
                      <StaticImage
                        src="../../images/contact/location_icn.png"
                        alt="Location_Icon"
                        className={styles.locationIcon}
                        placeholder="none"
                        quality={100}
                      />
                      <span className={styles.cardTitle}>Regional Office</span>
                    </div>
                    <p className={styles.cardAddress}>
                      218A 191, 5th Floor, Indiqube Hexa, Sector 6, HSR Layout,
                      Bengaluru, Karnataka – 560102
                    </p>
                  </div>

                  {/* Phone & Email */}
                  <div className={styles.contactLinksBlock}>
                    <a href="tel:9005008946" className={styles.contactLink}>
                      <StaticImage
                        src="../../images/contact/phone-icn.png"
                        alt="Phone"
                        className={styles.contactIcon}
                        placeholder="none"
                        quality={100}
                      />
                      <span className={styles.contactText}>9005008946</span>
                    </a>
                    <a
                      href="mailto:care@twinhealth.com"
                      className={styles.contactLink}
                    >
                      <StaticImage
                        src="../../images/contact/mail-icn.png"
                        alt="Email"
                        className={styles.contactIcon}
                        placeholder="none"
                        quality={100}
                      />
                      <span className={styles.contactText}>
                        care@twinhealth .com
                      </span>
                    </a>
                  </div>
                </div>

                {/* CIN */}
                <div className={styles.cinBlock}>
                  <p className={styles.cinText}>CIN: U72900TN2018FTC125517</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FormBanner;
